export default __webpack_public_path__ + "static/media/8.a5b9a3fb.jpg";